// g2-effective-plan-tickets.ts
//
// "Effective plan" ticket filtering, split out of g2-plan-gate-decision.ts to
// keep that file ≤200 lines and its decision function easy to scan as one
// pure block. Leaf module: only needs Ticket + isBootstrapTicketKind.
import { isBootstrapTicketKind } from "./feature-dispatch-gate-guard.js";
import type { Ticket } from "./schemas/ticket-schema.js";

/** Statuses that take a ticket out of the "effective plan" (spec: "ticket plan HIỆU LỰC"). */
const NON_EFFECTIVE_STATUSES: readonly string[] = ["cancelled", "superseded"];

function isEffective(ticket: Ticket, ticketStatus: Record<string, string>): boolean {
  const status = ticketStatus[ticket.id];
  return status === undefined || !NON_EFFECTIVE_STATUSES.includes(status);
}

/**
 * Tickets that count as "plan work". Excludes the controller's own bootstrap
 * seeds (T-0001 survey, T-0002 plan): counting them would inflate every
 * mission by two and shift the threshold's meaning.
 */
export function effectivePlanTickets(
  tickets: Ticket[],
  ticketStatus: Record<string, string>,
): Ticket[] {
  return tickets.filter((t) => isEffective(t, ticketStatus) && !isBootstrapTicketKind(t.kind));
}

/** Same "effective plan work" rule the decision uses — exported so the high-water mark counts the SAME thing (Bug L, D16). */
export function countEffectivePlanTickets(
  tickets: Ticket[],
  ticketStatus: Record<string, string>,
): number {
  return effectivePlanTickets(tickets, ticketStatus).length;
}
